<template>
  <div>
		<v-btn class="primary" small text @click="mostrarDialogo = true">Agregar Archivo/s</v-btn>

    <v-dialog v-model="mostrarDialogo" max-width="600px">
      <v-card>
        <v-card-title>Adjuntar Archivos</v-card-title>
        <v-file-input
          v-model="archivos"
          class="pa-4"
          multiple
          outlined
          type="file"
        >
          <template v-slot:selection="{ text }">
            <v-chip small label color="primary">
              {{ text }}
            </v-chip>
          </template>
        </v-file-input>

				<v-card-actions class="d-flex justify-space-around">
					<v-btn class="grey"    text @click="mostrarDialogo = false">Cerrar</v-btn>
					<v-btn class="primary" text @click="agregarArchivos">Agregar</v-btn>
				</v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
export default {

	props:['infoProyecto'],
	data() {
		return {
			mostrarDialogo:false,

			archivos:[],
		}
	},

	computed: {
		...mapGetters(['getURLAPI','getUsuario'])
	},

	methods: {
		agregarArchivos(){
			const datosForm = new FormData();

			datosForm.append("PROYECTO_ID",		this.infoProyecto.PID);
			datosForm.append("FOLIO", this.infoProyecto.FOLIO);
			datosForm.append("USUARIO_CREADOR",this.getUsuario);

			for (let archivo of this.archivos) {
				datosForm.append("ARCHIVOS[]", archivo, archivo.name);
			}

			console.log(this.infoProyecto);

			axios.post(`${this.getURLAPI}/Proyecto/agregarArchivo`, datosForm)
			.then( ( { data }) =>{
				console.log(data);
				this.$emit('snackbar', data);
				this.$emit('getInformacionProyecto',this.$route.params['id']);
				this.mostrarDialogo = false;
			} )
			.catch( ()=>{

				this.$emit('snackbar',{
					"STATUS" : "ERROR",
					"MSG" 	 : "ERROR AL CONECTAR CON EL SERVIDOR."
					});
				this.$emit('getInformacionProyecto',this.$route.params['id']);
				
			})
		}
	},
};
</script>

<style></style>
